module.exports = __webpack_public_path__ + "static/media/ic_delete.1cb9c687.svg";